var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tab',{on:{"click":_vm.toggleSearchBar}},[_vm._v(" 搜尋 ")])}
var staticRenderFns = []

export { render, staticRenderFns }